(() => {
    console.log('%c👍🏼 Hero Slide Out', 'color: yellow');
    const section = document.querySelector('.hero-slide-in-section');
    const heroVideo = section.querySelector('video');
    const slideInSection = section.querySelector('.hero-slide-in-section__slide-in-section');
    const sentinal = section.querySelector('.hero-slide-in-section__sentinal-50');
    const audioToggle = section.querySelector('.hero-slide-in-section__audio-toggle');
    const discoverMore = section.querySelector('.hero-slide-in-section__discover button');
    const nextElement = section.nextElementSibling;
    // const cta = section.querySelector('.hero-slide-in-section__slide-in-section button');
    let minScale = 0.1;
    const infoSections = slideInSection.querySelectorAll('[data-slide-in-from]');

    const calculateMinScale = () => {
        if (window.innerWidth < 768) {
            minScale = 0.3;
        } else {
            minScale = 0.1;
        }
    }

    calculateMinScale();

    window.addEventListener('resize', calculateMinScale);

    const scrollHandler = () => {
        // Calculate the scale factor based on the scroll position
        const scale = Math.min(1, Math.max(minScale, 1 - ((window.innerHeight - window.scrollY) / this.window.innerHeight)));
       
        // Apply the scale transformation to the element
        heroVideo.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';

        if (window.scrollY > 10) {
            heroVideo.style.opacity = 0.8;

            if (scale === minScale) {
                // console.log('minscale equal', scale, minScale)
                heroVideo.classList.remove('object-cover');
                heroVideo.classList.add('object-contain');
            }
        } 
    };

    const scrollObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                window.addEventListener('scroll', scrollHandler);
            } else {
                window.removeEventListener('scroll', scrollHandler);
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0
    });

    scrollObserver.observe(section);
    let lastScrollPosition = window.scrollY;


    // discover.addEventListener('click', event => {
    //     console.log('discover', discover);
    //     discover.classList.add('hidden');
    // })


    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const currentScrollPosition = window.scrollY;
            let scrollingDown;

            if (currentScrollPosition > lastScrollPosition) {
              // Scrolling down
            //   console.log('Scrolling down', entry.intersectionRatio);
              scrollingDown = true;
            } else {
              // Scrolling up
            //   console.log('Scrolling up', entry.intersectionRatio);
              scrollingDown = false;
            }
          
            lastScrollPosition = currentScrollPosition;
            if (! entry.isIntersecting) {
                // console.log('is intersectung')
                infoSections.forEach((infoSection) => {
                 
                    const direction = infoSection.dataset.slideInFrom;
                    if(!scrollingDown) {
                        // console.log('is intersectung', direction, 'Scrolling down' )
                        if (direction === 'left') {
                            infoSection.classList.remove('opacity-0', '-translate-x-[50vw]', 'hello');
                        } else if (direction === 'right') {
                            infoSection.classList.remove('opacity-0', 'translate-x-[50vw]', 'hello');
                        }
                    } else {
                        discoverMore.classList.add('opacity-0');
                        if(audioToggle){
                            audioToggle.classList.add('opacity-0', 'translate-x-[50vw]');

                        }
                        
                    }
                   
                });

                // cta.classList.remove('opacity-0');
            } else {
                // console.log('bye', entry.intersectionRatio);
                // console.log('not intersectung')
                infoSections.forEach((infoSection) => {
                    const direction = infoSection.dataset.slideInFrom;
                    // console.log('not intersectung', direction )
                    if (direction === 'left') {
                        infoSection.classList.add('opacity-0', '-translate-x-[50vw]');
                    } else if (direction === 'right') {
                        infoSection.classList.add('opacity-0', 'translate-x-[50vw]');
                    }
                    if(!scrollingDown) {
                        discoverMore.classList.remove('opacity-0');
                        if(audioToggle){
                            audioToggle.classList.remove('opacity-0', 'translate-x-[50vw]');
                        }

                    }
                });
                // cta.classList.add('opacity-0');
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0.5 // trigger when 30% of the section is in view
    });

    observer.observe(sentinal);

    const observer2 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                heroVideo.classList.add('hidden');
                slideInSection.classList.add('hidden');
                heroVideo.pause();
            } else {
                heroVideo.classList.remove('hidden');
                slideInSection.classList.remove('hidden');
                heroVideo.play();
            }
        });
    }, {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin around the root
        threshold: 0 // trigger when 30% of the section is in view
    });

    observer2.observe(section);

    const setupAudioToggle = () => {
       
        const muteIcon = audioToggle.querySelector('[data-audio-toggle="mute"]');
        const unmuteIcon = audioToggle.querySelector('[data-audio-toggle="unmute"]');

        const toggleAudio = (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            // if video sound is on, turn it off
            if (!heroVideo.muted) {
                heroVideo.muted = true;
                muteIcon.classList.add('hidden');
                unmuteIcon.classList.remove('hidden');
            } else {
                heroVideo.muted = false;
                muteIcon.classList.remove('hidden');
                unmuteIcon.classList.add('hidden');

                if (!audioToggle.dataset.clicked) {
                    audioToggle.dataset.clicked = 'true';

                    // restart video
                    heroVideo.currentTime = 0;
                    heroVideo.play();
                }
            }
        };

        // Add click event listener
        audioToggle.addEventListener('click', toggleAudio);
    };

    if(audioToggle){
        setupAudioToggle();
    }
    
    const addScrollToEvent = () => {
        if (!discoverMore) {
            return;
        }
       
        

        discoverMore.addEventListener('click', () => {
            discoverMore.classList.add('opacity-0');
            // window.scrollTo({
            //     top: 3000,
            //     left: 0,
            //     behavior: "smooth"
            // });
            nextElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    };

    addScrollToEvent();
})();